import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function RequestModalRemove(props) {
  const { show, onHide, model } = props;

  const [log, setLog] = useState('');
  const [loading, setLoading] = useState('');

  //Очистка форм
  useEffect(() => {
    if (show === false) {
      setLog(null);
      setLoading(false);
    }

  }, [show]);

  function removeHandler() {
    setLoading(true);

    axios.post('/api_main/company/requestAdminRemove', { ID_Request: model.ID, ID_Service: process.env.REACT_APP_ID_SERVICE })
      .then((res) => {
        if (res.data.Status === 1) {
          onHide();
        }
        else {
          setLog(res.data.Error);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
        ErrorAdd(err, window.location.href);
      });
  }


  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Body>
          <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
          <div className="modal_title text-center mb-20">Удаление заявки</div>
          <div className="text-center mb-20">Подтвердите удаление заявки <b>«{model.User_Name}»</b></div>
          {log !== null && <div className="form_error text-center mt-15">{log}</div>}
          <div className="row mt-15">
            <div className="col-md-12 text-center">
              <SrvButton typeBtn="remove" onClick={() => removeHandler()} loading={loading} size={'lg'} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default RequestModalRemove;
